<div class="sb-step sb-step-activation-otp">
    <form class="sb-step__form" [formGroup]="formGroup">

      <!-- region Step container -->
      <div class="sb-step__form__content">
        <div class="sb-step__inner-container" formGroupName="activationMnpInfo">
          <div class="sb-form-block" style="margin-bottom: 25px !important;">
            <div class="sb-form-block__title">
              {{'ENTITY.ACTIVATION-MNP-INFO.TITLE' | translate}}
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-4 col-xs-12">
                    <wt-input-text [validateOnBlur]="true" class="flex__input" [maxLength]="FormConstants.MAXIMUM_MOBILE_NUMBER_LENGTH" [label]="'ENTITY.ACTIVATION-MNP-INFO.MSISDN' | translate" type="tel" formControlName="msisdn"></wt-input-text>
                </div>
                <div class="col-md-4 col-sm-4 col-xs-12">
                    <wt-input-select [label]="'ENTITY.ACTIVATION-MNP-INFO.OPERATOR' | translate" [placeholder]="'ENTITY.ACTIVATION-MNP-INFO.OPERATOR' | translate" [items]="MnpOperators" formControlName="operator"></wt-input-select>
                </div>
                <div class="col-md-4 col-sm-4 col-xs-12">
                </div>
            </div>
            <div *ngIf="shouldShowOperatorMessage" @fadeAnimation>
              <sb-box-info [iconType]="['icon-magnifier']" [infoText]="'ENTITY.ACTIVATION-MNP-INFO.ALERT.OPERATORNOTLISTED' | translate"></sb-box-info>
            </div>
          </div>
          <ng-container *ngIf="shouldShowIccid">
            <div class="sb-form-block">
                <div class="sb-form-block__title inner-title">
                  {{'ENTITY.ACTIVATION-MNP-INFO.ICCID_TITLE' | translate}}
                </div>
                <div class="sb-form-block__fields">
                    <div class="row">
                        <div class="col-md-4 col-md-offset-0 col-sm-5 col-sm-offset-0 col-xs-12 input-complex">
                            <wt-input-text
                              [validateOnBlur]="false" class="flex__input"  [label]="'ENTITY.ACTIVATION-MNP-INFO.ICCID' | translate"
                              [maxLength]="FormConstants.MAXIMUM_ICCID_LENGTH"
                              formControlName="iccid"></wt-input-text>
                            <div class="input-complex-trigger" (click)="openModal()"></div>
                        </div>
                    </div>
                    <div *ngIf="shouldShowOperatorMessage" @fadeAnimation>
                      <sb-box-info [iconType]="['icon-magnifier']" [infoText]="'ENTITY.ACTIVATION-MNP-INFO.ALERT.OPERATORNOTLISTED' | translate"></sb-box-info>
                    </div>
                    <div class="wt-text-light-l ">
                        <ng-container *ngIf="!showTutorial">
                          <span class="wt-text-bold-l" [innerHTML]="'ENTITY.ACTIVATION-MNP-INFO.WHAT_IS_ICCID' | translate"></span>&nbsp;
                          <a class="wt-link" (click)="toggleVRTutorial()" [innerHTML]="'ENTITY.ACTIVATION-MNP-INFO.WHAT_IS_ICCID_SEE_VIDEO' | translate"></a>.
                        </ng-container>
                        <ng-container *ngIf="showTutorial">
                          <a class="wt-link" (click)="toggleVRTutorial()" [innerHTML]="'ENTITY.ACTIVATION-MNP-INFO.WHAT_IS_ICCID_HIDE_VIDEO' | translate"></a>&nbsp;
                        </ng-container>
                      </div>
                      <div class="tutorial-video wt-margin-top-4" [ngClass]="showTutorial ? 'visible' : ''">
                        <iframe width="688" height="387" title="Tutorial" src="https://www.youtube.com/embed/GfSpUoCew74?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      </div>
                </div>
            </div>
          </ng-container>

          <div class="sb-form-block">
            <div class="flex input-complex" >
                <wt-input-checkbox formControlName="esim">
                  <div class="wt-text-base-l sb-address-check" [innerHTML]="'ENTITY.ACTIVATION-MNP-INFO.ESIM' | translate"></div>
                </wt-input-checkbox>
                <div class="input-complex-trigger relative" (click)="openEsimInfoModal()"></div>
              </div>
          </div>
          <div class="sb-form-block">
            <span [innerHTML]="'ENTITY.ACTIVATION-MNP-INFO.SERVICE_CONDITIONS' | translate"></span>&nbsp;
              <a href="/assets/pdf/passa-a-very.pdf" class="wt-link wt-text-bold" target="_blank" >{{'ENTITY.ACTIVATION-MNP-INFO.SERVICE_CONDITIONS_LINK' | translate}}</a>.
          </div>
        </div>
      </div>
      <!-- endregion -->
      <!-- region Buttons -->
      <section class="sb-step__form__footer">
        <sb-navigation-buttons [isSticky]="shouldBeSticky" [submitDisabled]="isFormGroupInvalid" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()"></sb-navigation-buttons>
      </section>
      <!-- endregion -->
    </form>
  </div>
  <wt-modal [showCloseButton]="true" [isOpen]="shouldShowIccidModal" [additionalClasses]="'iccid-modal sb-modal'" (close)="closeModal()">
    <div class="sb-modal__content">
      <div class="sb-modal__section">
        <span class="sb-modal__title" [innerHTML]="'MODALS.ICCID.WHAT_IS.DESCRIPTION' | translate"></span>
      </div>
      <div class="sb-modal__section">
        <span class="sb-modal__text" [innerHTML]="'MODALS.ICCID.WHERE_IS.DESCRIPTION' | translate"></span>
      </div>
      <div class="sb-modal__section">
        <img src="assets/images/iccid.svg" class="sb-modal__image" alt="SIM" />
      </div>
      <div class="sb-modal__section">
        <span class="sb-modal__text" [innerHTML]="'MODALS.ICCID.WHERE_IS_IOS.DESCRIPTION' | translate"></span>
      </div>
      <div class="sb-modal__section">
        <span class="sb-modal__text" [innerHTML]="'MODALS.ICCID.NOT_19_DIGITS' | translate"></span>
      </div>
      <div class="sb-modal__section">
        <ul class="link-list">
          <li><a class="wt-link" rel="noopener" target="_blank" href="https://verymobile.it/supporto/passo-a-very/porto-il-mio-numero-in-very/liccid-della-mia-sim-ha-16-cifre-cosa-devo-fare/">Il mio ICCID ha 16 cifre</a></li>
          <li><a class="wt-link" rel="noopener" target="_blank" href="https://verymobile.it/supporto/passo-a-very/porto-il-mio-numero-in-very/liccid-della-mia-sim-ha-20-cifre-cosa-devo-fare/">Il mio ICCID ha 20 cifre</a></li>
          <li><a class="wt-link" rel="noopener" target="_blank" href="https://verymobile.it/supporto/passo-a-very/porto-il-mio-numero-in-very/liccid-della-mia-sim-ha-22-cifre-cosa-devo-fare/">Il mio ICCID ha 22 cifre</a></li>
          <li><a class="wt-link" rel="noopener" target="_blank" href="https://verymobile.it/supporto/passo-a-very/porto-il-mio-numero-in-very/liccid-della-mia-sim-ha-una-lettera-alla-fine-del-seriale-devo-inserirla/">Il mio ICCID contiene una lettera finale</a></li>
        </ul>
      </div>
      <div class="sb-modal__section">
        <wt-button (click)="closeModal()">{{'MODALS.ICCID.BUTTON.CONFIRM' | translate}}</wt-button>
      </div>
    </div>
  </wt-modal>
